import { render, staticRenderFns } from "./Q4.vue?vue&type=template&id=0de5c8bd&scoped=true&"
import script from "./Q4.vue?vue&type=script&lang=js&"
export * from "./Q4.vue?vue&type=script&lang=js&"
import style0 from "./Q4.vue?vue&type=style&index=0&id=0de5c8bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de5c8bd",
  null
  
)

export default component.exports